import _ from 'lodash';
import { GET_SORTING_HISTORY,
    GET_SORTING_HISTORY_SUCCESS,
    GET_SORTING_HISTORY_FAIL,
    GET_SORTING_HISTORY_LIST,
    GET_SORTING_HISTORY_LIST_SUCCESS,
    GET_SORTING_HISTORY_LIST_FAIL,
    SAVE_SORTING_HISTORY,
    SAVE_SORTING_HISTORY_SUCCESS,
    SAVE_SORTING_HISTORY_FAIL,
    APPLY_CONFIGURATION,
    APPLY_CONFIGURATION_SUCCESS,
    APPLY_CONFIGURATION_FAIL,
    GET_WAREHOUSE_TOTAL_SLOTS,
    GET_WAREHOUSE_TOTAL_SLOTS_SUCCESS,
    GET_WAREHOUSE_TOTAL_SLOTS_FAIL,
    GET_BATCH_ALL,
    GET_BATCH_ALL_SUCCESS,
    GET_BATCH_ALL_FAIL,
    GET_BATCH_ORDER_ALL,
    GET_BATCH_ORDER_ALL_SUCCESS,
    GET_BATCH_ORDER_ALL_FAIL,
    GET_BATCH_INFO_ALL,
    GET_BATCH_INFO_ALL_SUCCESS,
    GET_BATCH_INFO_ALL_FAIL,
    GET_DRIVER_ORDER_COUNT_ALL,
    GET_DRIVER_ORDER_COUNT_ALL_SUCCESS,
    GET_DRIVER_ORDER_COUNT_ALL_FAIL,
    GET_DISTRICT_ALL,
    GET_DISTRICT_ALL_SUCCESS,
    GET_DISTRICT_ALL_FAIL,
    GET_STAFF_LIST_ALL,
    GET_STAFF_LIST_ALL_SUCCESS,
    GET_STAFF_LIST_ALL_FAIL,
    GET_BLIND_SCAN_BATCH,
    GET_BLIND_SCAN_BATCH_SUCCESS,
    GET_BLIND_SCAN_BATCH_FAIL,
    SET_BLIND_BATCH,
    SET_BLIND_BATCH_SUCCESS,
    SET_BLIND_BATCH_FAIL,
    SET_SCAN_MODE,
    SET_SCAN_MODE_SUCCESS,
    SET_SCAN_MODE_FAIL,
    GET_MACHINE_CONFIG,
    GET_MACHINE_CONFIG_SUCCESS,
    GET_MACHINE_CONFIG_FAIL,
    SET_SCAN_BATCH_LIST,
    SET_SCAN_BATCH_LIST_SUCCESS,
    SET_SCAN_BATCH_LIST_FAIL,
    CREATE_ZONE_SLOT_MAPPING,
    CREATE_ZONE_SLOT_MAPPING_SUCCESS,
    CREATE_ZONE_SLOT_MAPPING_FAIL,
    GET_ZONE_SLOT_MAPPING,
    GET_ZONE_SLOT_MAPPING_SUCCESS,
    GET_ZONE_SLOT_MAPPING_FAIL,
    EDIT_ZONE_SLOT_MAPPING,
    EDIT_ZONE_SLOT_MAPPING_SUCCESS,
    EDIT_ZONE_SLOT_MAPPING_FAIL,
    GET_PATTERN_ID_TYPE,
    GET_PATTERN_ID_TYPE_SUCCESS,
    GET_PATTERN_ID_TYPE_FAIL,
    GET_SORT_MANAGEMENT_LIST,
    GET_SORT_MANAGEMENT_LIST_SUCCESS,
    GET_SORT_MANAGEMENT_LIST_FAIL,
    EDIT_SORTING_MANAGEMENT,
    EDIT_SORTING_MANAGEMENT_SUCCESS,
    EDIT_SORTING_MANAGEMENT_FAIL,
    GET_ALL_MACHINE_CODES,
    GET_ALL_MACHINE_CODES_SUCCESS,
    GET_ALL_MACHINE_CODES_FAIL
} from '../actions/types';

const initialState = {
    getSortingHistory: {},
    getSortingHistoryLoading: false,
    getSortingHistoryError: false,
    getSortingHistoryList: {},
    getSortingHistoryListLoading: false,
    getSortingHistoryListError: false,
    saveSortingHistory: {},
    saveSortingHistoryLoading: false,
    saveSortingHistoryError: false,
    applyConfiguration: {},
    applyConfigurationLoading: false,
    applyConfigurationError: false,
    getWarehouseTotalSlots: 0,
    getWarehouseTotalSlotsLoading: false,
    getWarehouseTotalSlotsError: false,
    batches: [],
    batchesLoading: false,
    batchError: false,
    batchByDistrict: [],
    batchByDistrictLoading: false,
    batchByDistrictError: false,
    batchInfo: {},
    batchInfoLoading: false,
    staff: [],
    staffLoading: false,
    staffError: false,
    batchByDistrict: [],
    batchByDistrictLoading: false,
    batchByDistrictError: false,
    getBlindScanBatch: [],
    getBlindScanBatchLoading: false,
    getBlindScanBatchError: false,
    setBlindBatch: {},
    setBlindBatchLoading: false,
    setBlindBatchError: false,
    setScanMode: {},
    setScanModeLoading: false,
    setScanModeError: false,
    getMachineConfig: {},
    getMachineConfigLoading: false,
    getMachineConfigError: false,
    setScanBatchList: {},
    setScanBatchListLoading: false,
    setScanBatchListError: false,
    createZoneSlotMapping: {},
    createZoneSlotMappingLoading: false,
    createZoneSlotMappingError: false,
    getZoneSlotMapping: {},
    getZoneSlotMappingLoading: false,
    getZoneSlotMappingError: false,
    editZoneSlotMapping: {},
    editZoneSlotMappingLoading: false,
    editZoneSlotMappingError: false,
    getPatternIdType: [],
    getPatternIdTypeLoading: false,
    getPatternIdTypeError: false,
    getSortManagementList: [],
    getSortManagementListLoading: false,
    getSortManagementListError: false,
    getAllMachinesCodes: [],
    getAllMachinesCodesLoading: false,
    getAllMachinesCodesError: false,
    editSortingManagement: [],
    editSortingManagementLoading: false,
    editSortingManagementError: false
}

export default function smReducer(state = initialState, action){
    switch(action.type){
        case GET_ALL_MACHINE_CODES:
            return {
                ...state,
                getAllMachinesCodesLoading: true,
            }
        case GET_ALL_MACHINE_CODES_SUCCESS:
            return {
                ...state,
                getAllMachinesCodes: action.payload,
                getAllMachinesCodesLoading: false
            }
        case GET_ALL_MACHINE_CODES_FAIL:
            return {
                ...state,
                getAllMachinesCodesLoading: false,
                getAllMachinesCodesError : action.payload
            }
        case EDIT_SORTING_MANAGEMENT:
            return {
                ...state,
                editSortingManagementLoading: true,
            }
        case EDIT_SORTING_MANAGEMENT_SUCCESS:
            return {
                ...state,
                editSortingManagement: action.payload,
                editSortingManagementLoading: false
            }
        case EDIT_SORTING_MANAGEMENT_FAIL:
            return {
                ...state,
                editSortingManagementLoading: false,
                editSortingManagementError : action.payload
            }
        case GET_SORT_MANAGEMENT_LIST:
            return {
                ...state,
                getSortManagementListLoading: true,
            }
        case GET_SORT_MANAGEMENT_LIST_SUCCESS:
            return {
                ...state,
                getSortManagementList: action.payload,
                getSortManagementListLoading: false
            }
        case GET_SORT_MANAGEMENT_LIST_FAIL:
            return {
                ...state,
                getSortManagementListLoading: false,
                getSortManagementListError : action.payload
            }
        case GET_PATTERN_ID_TYPE:
            return {
                ...state,
                getPatternIdTypeLoading: true,
            }
        case GET_PATTERN_ID_TYPE_SUCCESS:
            return {
                ...state,
                getPatternIdType: action.payload,
                getPatternIdTypeLoading: false
            }
        case GET_PATTERN_ID_TYPE_FAIL:
            return {
                ...state,
                getPatternIdTypeLoading: false,
                getPatternIdTypeError : action.payload
            }
        case GET_SORTING_HISTORY:
            return {
                ...state,
                getSortingHistoryLoading: true,
            }
        case GET_SORTING_HISTORY_SUCCESS:
            return {
                ...state,
                getSortingHistory: action.payload,
                getSortingHistoryLoading: false
            }
        case GET_SORTING_HISTORY_FAIL:
            return {
                ...state,
                getSortingHistoryLoading: false,
                getSortingHistoryError : action.payload
            }
        case GET_SORTING_HISTORY_LIST:
            return {
                ...state,
                getSortingHistoryListLoading: true,
            }
        case GET_SORTING_HISTORY_LIST_SUCCESS:
            return {
                ...state,
                getSortingHistoryList: action.payload,
                getSortingHistoryListLoading: false
            }
        case GET_SORTING_HISTORY_LIST_FAIL:
            return {
                ...state,
                getSortingHistoryListLoading: false,
                getSortingHistoryListError : action.payload
            }
        case SAVE_SORTING_HISTORY:
            return {
                ...state,
                saveSortingHistoryLoading: true,
            }
        case SAVE_SORTING_HISTORY_SUCCESS:
            return {
                ...state,
                saveSortingHistory: action.payload,
                saveSortingHistoryLoading: false
            }
        case SAVE_SORTING_HISTORY_FAIL:
            return {
                ...state,
                saveSortingHistoryLoading: false,
                saveSortingHistoryError : action.payload
            }
        case APPLY_CONFIGURATION:
            return {
                ...state,
                applyConfigurationLoading: true,
            }
        case APPLY_CONFIGURATION_SUCCESS:
            return {
                ...state,
                applyConfiguration: action.payload,
                applyConfigurationLoading: false
            }
        case APPLY_CONFIGURATION_FAIL:
            return {
                ...state,
                applyConfigurationLoading: false,
                applyConfigurationError : action.payload
            }
        case GET_WAREHOUSE_TOTAL_SLOTS:
            return {
                ...state,
                getWarehouseTotalSlotsLoading: true,
            }
        case GET_WAREHOUSE_TOTAL_SLOTS_SUCCESS:
            return {
                ...state,
                getWarehouseTotalSlots: action.payload,
                getWarehouseTotalSlotsLoading: false
            }
        case GET_WAREHOUSE_TOTAL_SLOTS_FAIL:
            return {
                ...state,
                getWarehouseTotalSlotsLoading: false,
                getWarehouseTotalSlotsError : action.payload
            }
        case GET_BATCH_ALL:
            return {
                ...state,
                batchesLoading: true
            }
        case GET_BATCH_ALL_SUCCESS:
            return {
                ...state,
                batches: action.payload,
                batchesLoading: false
            }
        case GET_BATCH_ALL_FAIL:
            return {
                ...state,
                batchesLoading: false,
                batchError: action.payload
            }
        case GET_BATCH_ORDER_ALL:
            return {
                ...state,
                batchByDistrictLoading: true
            }
        case GET_BATCH_ORDER_ALL_SUCCESS:
            let district = []
            _.map(action.payload.data, function(value, key){
                district.push({id: parseInt(key), orderIds: value})
            })
            return {
                ...state,
                batchByDistrictLoading: false,
                batchByDistrict: district,
                //orderList: action.payload.data.orders
            }
        case GET_BATCH_ORDER_ALL_FAIL:
            return {
                ...state,
                batchByDistrictLoading: false,
                batchByDistrictError: action.payload
            }
        case GET_BATCH_INFO_ALL:
            return {
                ...state,
                batchInfoLoading: true
            }
        case GET_BATCH_INFO_ALL_SUCCESS:
            return {
                ...state,
                batchInfoLoading: false,
                batchInfo: action.payload
            }
        case GET_BATCH_INFO_ALL_FAIL:
            return {
                ...state,
                batchInfoLoading: false
            }
        case GET_DRIVER_ORDER_COUNT_ALL:
            return {
                ...state,
                staffLoading: true
            }
        case GET_DRIVER_ORDER_COUNT_ALL_SUCCESS:
            let updateArray = action.payload
            let oldArray = _.cloneDeep(state.staff)
            _.map(updateArray, function(order){
                let index = _.findIndex(oldArray, {'id': order.driver_id})
                if(index !== -1){
                    oldArray[index]['order_count'] = order.order_count
                }
            })
            return {
                ...state,
                staffLoading: false,
                staff: oldArray
            }
        case GET_DRIVER_ORDER_COUNT_ALL_FAIL:
            return {
                ...state,
                staffLoading: false
            }
        case GET_DISTRICT_ALL:
            return {
                ...state,
                districtLoading: true,
                districtError: false
            }
        case GET_DISTRICT_ALL_SUCCESS:
            window.localStorage.setItem('districts', JSON.stringify(action.payload))
            return {
                ...state,
                districtLoading: false,
                //districts: action.payload
            }
        case GET_DISTRICT_ALL_FAIL:
            return {
                ...state,
                districtLoading: false,
                districtError: action.payload
            }
        case GET_STAFF_LIST_ALL:
            return {
                ...state,
                staffLoading: true,
                staffError: false
            }
        case GET_STAFF_LIST_ALL_SUCCESS:
            return {
                ...state, 
                staffLoading: false,
                staff: action.payload.data
            }
        case GET_STAFF_LIST_ALL_FAIL:
            return {
                ...state,
                staffLoading: false,
                staffError: action.payload
            }
        case GET_BLIND_SCAN_BATCH:
            return {
                ...state,
                getBlindScanBatchLoading: true
            }
        case GET_BLIND_SCAN_BATCH_SUCCESS:
            return {
                ...state,
                getBlindScanBatch: action.payload,
                getBlindScanBatchLoading: false
            }
        case GET_BLIND_SCAN_BATCH_FAIL:
            return {
                ...state,
                getBlindScanBatchLoading: false,
                getBlindScanBatchError : action.payload
            }
        case SET_BLIND_BATCH:
            return {
                ...state,
                setBlindBatchLoading: true
            }
        case SET_BLIND_BATCH_SUCCESS:
            return {
                ...state,
                setBlindBatch: action.payload,
                setBlindBatchLoading: false
            }
        case SET_BLIND_BATCH_FAIL:
            return {
                ...state,
                setBlindBatchLoading: false,
                setBlindBatchError : action.payload
            }    
        case SET_SCAN_MODE:
            return {
                ...state,
                setScanModeLoading: true
            }
        case SET_SCAN_MODE_SUCCESS:
            return {
                ...state,
                setScanMode: action.payload,
                setScanModeLoading: false
            }
        case SET_SCAN_MODE_FAIL:
            return {
                ...state,
                setScanModeLoading: false,
                setScanModeError : action.payload
            }
        case GET_MACHINE_CONFIG:
            return {
                ...state,
                getMachineConfigLoading: true
            }
        case GET_MACHINE_CONFIG_SUCCESS:
            return {
                ...state,
                getMachineConfig: action.payload,
                getMachineConfigLoading: false
            }
        case GET_MACHINE_CONFIG_FAIL:
            return {
                ...state,
                getMachineConfigLoading: false,
                getMachineConfigError : action.payload
            }
        case SET_SCAN_BATCH_LIST:
            return {
                ...state,
                setScanBatchListLoading: true
            }
        case SET_SCAN_BATCH_LIST_SUCCESS:
            return {
                ...state,
                setScanBatchList: action.payload,
                setScanBatchListLoading: false
            }
        case SET_SCAN_BATCH_LIST_FAIL:
            return {
                ...state,
                setScanBatchListLoading: false,
                setScanBatchListError : action.payload
            }
        case CREATE_ZONE_SLOT_MAPPING:
            return {
                ...state,
                createZoneSlotMappingLoading: true
            }
        case CREATE_ZONE_SLOT_MAPPING_SUCCESS:
            return {
                ...state,
                createZoneSlotMapping: action.payload,
                createZoneSlotMappingLoading: false
            }
        case CREATE_ZONE_SLOT_MAPPING_FAIL:
            return {
                ...state,
                createZoneSlotMappingLoading: false,
                createZoneSlotMappingError : action.payload
            }
        case GET_ZONE_SLOT_MAPPING:
            return {
                ...state,
                getZoneSlotMappingLoading: true
            }
        case GET_ZONE_SLOT_MAPPING_SUCCESS:
            return {
                ...state,
                getZoneSlotMapping: action.payload,
                getZoneSlotMappingLoading: false
            }
        case GET_ZONE_SLOT_MAPPING_FAIL:
            return {
                ...state,
                getZoneSlotMappingLoading: false,
                getZoneSlotMappingError : action.payload
            }
        case EDIT_ZONE_SLOT_MAPPING:
            return {
                ...state,
                editZoneSlotMappingLoading: true
            }
        case EDIT_ZONE_SLOT_MAPPING_SUCCESS:
            return {
                ...state,
                editZoneSlotMapping: action.payload,
                editZoneSlotMappingLoading: false
            }
        case EDIT_ZONE_SLOT_MAPPING_FAIL:
            return {
                ...state,
                editZoneSlotMappingLoading: false,
                editZoneSlotMappingError : action.payload
            }
        default:
            return state;
    }
}